import React, { useMemo } from 'react'
import { TextField as ShellTextField, TextFieldBaseProps } from '@e3dc-react/shell/Elements/InputFields/TextField'
import { useTheme } from '@mui/material'
import { useField } from 'formik'

/**
 * Base component for formik textfields.
 * Does not handle any change events or values, as this has to be done by the wrapper components (TextField)
 */
const TextFieldBase: React.FC<TextFieldBaseProps> = React.forwardRef<typeof ShellTextField, TextFieldBaseProps>((props, ref) => {
  const { onChange, onFocus, onBlur, name, value } = props
  const { palette, shape } = useTheme()
  const [, meta] = useField(name as string)

  const hasError = useMemo<boolean>(() => {
    return Boolean(meta.error && meta.touched)
  }, [meta])

  const helperText = useMemo<string | undefined>(() => {
    return meta.error
  }, [meta.error])

  return (
    <ShellTextField
      {...props}
      ref={ref}
      sx={{
        '.MuiInputBase-root': {
          backgroundColor: palette.background.changedInputField,
          fontSize: shape.inputField.fontSize,
          '& input': {
            textAlign: props.textAlign,
          },
        },
      }}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      value={value}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      error={hasError}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      helperText={hasError ? helperText : undefined}
      useTooltipErrorMessage={false}
      disableAutoComplete={true}
    />
  )
})

TextFieldBase.displayName = 'TextFieldBase'

export default TextFieldBase
